import { useUsers } from 'hooks/useUsers.hooks'
import UsersDataGrid from '../view-users/UsersDataGrid'
import { Button, Grid } from '@mui/material'
import { Link } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import { IUser } from 'types/user.interface';
import { useState } from 'react';


const AdminArchivedDeliveryDriverScreen = function() {
  const usersState = useUsers('Delivery Driver', false)
  const [, setUser] = useState<IUser>(null);

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item xs={12}>
      <Button variant="contained" component={Link} to='/delivery-drivers'>
          Return to Active Delivery Drivers
      </Button>
      </Grid>
      
      <Grid item xs={12}>
      <MainCard title="Archived Delivery Drivers">
      {!usersState.ready ? (
        <div>Loading</div>
      ) : (
        <UsersDataGrid
          setUser={setUser}
          role="Delivery Driver"
          active={false}
        />
      )}
      </MainCard>
      </Grid>
    </Grid>
  )
}

export default AdminArchivedDeliveryDriverScreen